export enum PrivilegesAccessType {
    RW = 'RW',
    R = 'R',
    NoAccess = 'No Access'
}